import React, { useEffect, useState } from "react";

import axios from "axios";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import UserAdd from "./UserAdd";
import UserListTable from "./UserListTable";
export default function UserList() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  let [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(1);
  let [pageNumberAdmin, setPageNumberAdmin] = useState(1);
  let [pageLimitAdmin, setPageLimitAdmin] = useState(1);
  let [pageNumberArchive, setPageNumberArchive] = useState(1);
  let [pageLimitArchive, setPageLimitArchive] = useState(1);

  // const [pageLimit, setPageLimit] = useState(1);
  // let [pageLimitAdmin, setPageLimitAdmin] = useState(1);
  // let [pageNumberArchive, setPageNumberArchive] = useState(1);

  // const [paginationDetails, setPaginationDetails] = useState({});
  const [paginationDetails, setPaginationDetails] = useState({});
  const [paginationDetailsAdmin, setPaginationDetailsAdmin] = useState({});
  const [paginationDetailsArchive, setPaginationDetailsArchive] = useState({});
  // let [pageLimitAdmin, setPageLimitAdmin] = useState(1);
  // let [pageNumberArchive, setPageNumberArchive] = useState(1);

  const [userData, setUserData] = useState([]);
  const [adminData, setAdminData] = useState([]);
  const [archiveData, setArchiveData] = useState([]);
  const [userCount, setUserCount] = useState([]);
  const [adminCount, setAdminCount] = useState([]);
  const [modelType, setModelType] = useState("ADMIN_MANAGER");

  const [archivecount, setArchiveCount] = useState();
  const [showModel, setShowModel] = useState(1);
  const [archivedVal, setArchivedVal] = useState("Archived");
  let [companyNameData, setCompanyNameData] = useState([]);
  let [searchData, setSearchData] = useState({ company: "", user_type: "" });
  let [modelPageCountType, setmodelPageCountType] = useState("user");
  // let [searchDataAdmin, setSearchDataAdmin] = useState({ company: "" })
  // let [searchDataArchive, setSearchDataArchive] = useState({ company: "", user_type: "" })

  // Add state for EDU counts
  const [edu_user_count, setEduUserCount] = useState(0);
  const [edu_admin_count, setEduAdminCount] = useState(0);
  const [edu_archive_count, setEduArchiveCount] = useState(0);

  // Add tabSelected state like bus module
  const [tabSelected, setTabSelected] = useState("user");

  // Determine logged-in user's role
  const loginUser = JSON.parse(localStorage.getItem("user") || "{}");
  const loginUserType = loginUser?.user_type;

  // Helper to check if this is EDU
  const isEdu = window.location.pathname.includes("edu");

  //Admin Data api
  const adminDataApi = async () => {
    try {
      let apiUrl;

      // Check if this is education module
      if (isEdu) {
        // Use create_user_manager API for education module
        apiUrl = `${baseUrl}/create_user_manager/?per_page=${pageLimitAdmin}&page=${pageNumberAdmin}`;
      } else {
        // Use original admin API for bus module
        apiUrl = `${baseUrl}/module/admin/adminlist?page=${pageNumberAdmin}&company=${searchData.company}`;
      }

      let response = await axios(apiUrl, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });

      if (response?.data.code === 401) {
        navigate("/login");
        return;
      }

      if (isEdu) {
        // Handle education module response
        setAdminData(response?.data?.data || []);
        setPaginationDetailsAdmin(response?.data?.extra);
        setPageLimitAdmin(response?.data?.extra?.total);
        setAdminCount(response?.data?.extra?.total || 0);
      } else {
        // Handle bus module response
        setAdminData(response?.data?.data || []);
        setPaginationDetailsAdmin(response?.data?.extra);
        setPageLimitAdmin(response?.data?.extra?.total);
      }
      setArchivedVal("Archived");
    } catch (error) {
      console.error("Error fetching admin data:", error);
      setAdminData([]);
      setAdminCount(0);
    }
  };
  useEffect(() => {
    if (tabSelected === "admin") {
      adminDataApi();
    }
  }, [pageNumberAdmin, tabSelected]);

  //user Data Api
  const usersDataApi = async () => {
    let apiUrl;

    // Check if this is education module
    if (isEdu) {
      // Use get_user API for education module
      apiUrl = `${baseUrl}/get_user/?per_page=${pageLimit}&page=${pageNumber}`;
    } else {
      // Use original user API for bus module
      apiUrl = `${baseUrl}/module/admin/user-viewset?page=${pageNumber}&company=${searchData.company}&user_type=${searchData?.user_type}`;
    }

    let response = await axios(apiUrl, {
      method: "GET",
      headers: {
        Authorization: "Token " + localStorage.getItem("token"),
      },
    });
    if (response?.data?.code === 401) {
      navigate("/login");
      return;
    }
    setPaginationDetails(response?.data?.extra);
    setUserData(response?.data?.data || []);
    setPageLimit(response?.data?.extra?.total);
    setArchivedVal("Archived");
  };

  let archiveUserData = async () => {
    setModelType("ADMIN_MANAGER");
    setArchivedVal("Restore");

    let apiUrl;

    // Check if this is education module
    if (isEdu) {
      // Use archive_user_list API for education module
      apiUrl = `${baseUrl}/archive_user_list/?per_page=${pageLimitArchive}&page=${pageNumberArchive}`;
    } else {
      // Use original archive API for bus module
      apiUrl = `${baseUrl}/module/admin/archive-viewset?page=${pageNumberArchive}`;
    }

    let response = await axios(apiUrl, {
      method: "GET",
      headers: {
        Authorization: "Token " + localStorage.getItem("token"),
      },
    });

    countApi();
    setArchiveData(response?.data?.data || []);
    setPageLimitArchive(response?.data?.extra?.total);
    setPaginationDetailsArchive(response?.data?.extra);
  };

  useEffect(() => {
    if (tabSelected === "archive") {
      archiveUserData();
    }
  }, [pageNumberArchive, tabSelected]);

  //company data
  const companyName = async () => {
    let response = await axios(`${baseUrl}/module/admin/company-list`, {
      method: "GET",
      headers: {
        Authorization: "Token " + localStorage.getItem("token"),
      },
    });
    setCompanyNameData(response?.data?.data || []);
  };

  useEffect(() => {
    if (tabSelected === "user") {
      usersDataApi();
    }
  }, [pageNumber, tabSelected]);

  // Also fetch when Cleaning Manager tab is selected (filters users by role)
  useEffect(() => {
    if (tabSelected === "cleaning_manager") {
      usersDataApi();
    }
  }, [pageNumber, tabSelected]);

  // Also fetch when Client tab is selected (filters users by role)
  useEffect(() => {
    if (tabSelected === "client") {
      usersDataApi();
    }
  }, [pageNumber, tabSelected]);

  useEffect(() => {
    countApi();
  }, [showModel]);

  useEffect(() => {
    companyName();
  }, []);

  //Archived User Get data

  // countApi
  let countApi = async () => {
    if (isEdu) {
      // EDU: use get_user, create_user_manager, archive_user_list counts
      try {
        const response = await axios(`${baseUrl}/count_api/`, {
          method: "GET",
          headers: { Authorization: "Token " + localStorage.getItem("token") },
        });
        // Assume response.data = { user_count: X, admin_count: Y, archive_count: Z }
        setEduUserCount(response?.data?.user_count || 0);
        setEduAdminCount(response?.data?.admin_count || 0);
        setEduArchiveCount(response?.data?.archive_count || 0);
      } catch (error) {
        setEduUserCount(0);
        setEduAdminCount(0);
        setEduArchiveCount(0);
      }
    } else {
      // BUS: keep existing logic
      let response = await axios(`${baseUrl}/module/admin/count-viewset`, {
        method: "GET",
        headers: { Authorization: "Token " + localStorage.getItem("token") },
      });
      setUserCount(response?.data?.user);
      setAdminCount(response?.data?.admin);
      setArchiveCount(response?.data?.archive);
    }
  };

  useEffect(() => {
    let queryString = searchParams.get("model");
    if (queryString === "admin") {
      let adminButton = document?.getElementById("adminButton");
      adminButton.click();
    }
    if (queryString === "archive") {
      let archiveButton = document?.getElementById("archiveButton");
      archiveButton.click();
    }
  }, []);

  return (
    <>
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-users me-2" />
                {modelType === "SUPER_ADMIN"
                  ? "Admin List"
                  : archivedVal === "Archived"
                  ? "Users List"
                  : "Archive List"}
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/"> Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {modelType === "SUPER_ADMIN"
                      ? "Admin"
                      : archivedVal === "Archived"
                      ? "Users"
                      : "Archive Users"}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cstm-tab">
              <ul className="nav" id="myTab">
                <li className="nav-item">
                  <button
                    className={`nav-link active`}
                    data-bs-toggle="tab"
                    data-bs-target="#tab-01"
                    type="button"
                    role="tab"
                    onClick={() => {
                      setSearchData({ company: "", user_type: "" });
                      searchData = { company: "", user_type: "" };
                      setModelType("ADMIN_MANAGER");
                      setArchivedVal("Archived");
                      setPageNumber(1);
                      setTabSelected("user");
                      setmodelPageCountType("user");
                    }}
                  >
                    Users &nbsp; ({isEdu ? edu_user_count : userCount})
                  </button>
                </li>
                {/* Cleaning Manager tab visible only for CLEANING_MANAGER role */}
                {loginUserType === "CLEANING_MANAGER" && (
                  <li className="nav-item">
                    <button
                      className={`nav-link`}
                      data-bs-toggle="tab"
                      data-bs-target="#tab-04"
                      type="button"
                      role="tab"
                      onClick={() => {
                        setSearchData({
                          company: "",
                          user_type: "CLEANING_MANAGER",
                        });
                        searchData = {
                          company: "",
                          user_type: "CLEANING_MANAGER",
                        };
                        setModelType("ADMIN_MANAGER");
                        setArchivedVal("Archived");
                        setPageNumber(1);
                        setTabSelected("cleaning_manager");
                        setmodelPageCountType("user");
                      }}
                    >
                      Cleaning Manager
                    </button>
                  </li>
                )}
                {/* Client tab visible only for CLIENT role */}
                {loginUserType === "CLIENT" && (
                  <li className="nav-item">
                    <button
                      className={`nav-link`}
                      data-bs-toggle="tab"
                      data-bs-target="#tab-05"
                      type="button"
                      role="tab"
                      onClick={() => {
                        setSearchData({ company: "", user_type: "CLIENT" });
                        searchData = { company: "", user_type: "CLIENT" };
                        setModelType("ADMIN_MANAGER");
                        setArchivedVal("Archived");
                        setPageNumber(1);
                        setTabSelected("client");
                        setmodelPageCountType("user");
                      }}
                    >
                      Client
                    </button>
                  </li>
                )}
                {loginUserType !== "CLEANING_MANAGER" && (
                <li className="nav-item">
                  <button
                    className={`nav-link`}
                    data-bs-toggle="tab"
                    data-bs-target="#tab-02"
                    type="button"
                    id="adminButton"
                    role="tab"
                    // onClick={() => setModelType("SUPER_ADMIN")}
                    onClick={() => {
                      setSearchData({ company: "", user_type: "" });
                      searchData = { company: "", user_type: "" };
                      setModelType("SUPER_ADMIN");
                      setArchivedVal("Archived");
                      setTabSelected("admin");
                      setmodelPageCountType("admin");
                    }}
                  >
                    Admin ({isEdu ? edu_admin_count : adminCount})
                  </button>
                </li>
                )}
                <li className="nav-item">
                  <button
                    className={`nav-link`}
                    data-bs-toggle="tab"
                    data-bs-target="#tab-03"
                    type="button"
                    role="tab"
                    id="archiveButton"
                    onClick={() => {
                      setSearchData({ company: "", user_type: "" });
                      searchData = { company: "", user_type: "" };
                      setArchivedVal("Restore");
                      setTabSelected("archive");
                      setmodelPageCountType("archive");
                    }}
                  >
                    ARCHIVED &nbsp; ({isEdu ? edu_archive_count : archivecount})
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <UserListTable
                  userData={userData}
                  setUserData={setUserData}
                  setArchiveData={setArchiveData}
                  archiveData={archiveData}
                  modelType={modelType}
                  setArchiveCount={setArchiveCount}
                  adminData={adminData}
                  setAdminData={setAdminData}
                  archivedVal={archivedVal}
                  pageLimit={pageLimit}
                  companyNameData={companyNameData}
                  countApi={countApi}
                  searchData={searchData}
                  setSearchData={setSearchData}
                  setPageNumber={setPageNumber}
                  pageNumber={pageNumber}
                  setPageLimit={setPageLimit}
                  setPageNumberAdmin={setPageNumberAdmin}
                  pageNumberAdmin={pageNumberAdmin}
                  setPageLimitAdmin={setPageLimitAdmin}
                  pageLimitAdmin={pageLimitAdmin}
                  pageNumberArchive={pageNumberArchive}
                  setPageNumberArchive={setPageNumberArchive}
                  pageLimitArchive={pageLimitArchive}
                  setPageLimitArchive={setPageLimitArchive}
                  paginationDetailsAdmin={paginationDetailsAdmin}
                  setPaginationDetailsAdmin={setPaginationDetailsAdmin}
                  paginationDetails={paginationDetails}
                  setPaginationDetails={setPaginationDetails}
                  paginationDetailsArchive={paginationDetailsArchive}
                  setPaginationDetailsArchive={setPaginationDetailsArchive}
                  modelPageCountType={modelPageCountType}
                  archiveUserDataApi={archiveUserData}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Add-user-modal-start  */}

      <UserAdd
        modelType={modelType}
        showModel={showModel}
        setShowModel={setShowModel}
        pageLimit={pageLimit}
        adminDataApi={adminDataApi}
        companyNameData={companyNameData}
      />
    </>
  );
}
